import { useState } from "react";
import { motion } from "framer-motion";
import { EASE } from "@/components/landing/Reveal";

const VERSES = [
  { ref: "Psalm 78:4", tr: "BSB", text: "…we will tell the next generation the praiseworthy deeds of the LORD, His power, and the wonders He has performed." },
  { ref: "Matthew 28:19", tr: "BSB", text: "Therefore go and make disciples of all nations, baptizing them in the name of the Father and of the Son and of the Holy Spirit." },
  { ref: "2 Timothy 2:2", tr: "BSB", text: "And the things you have heard me say among many witnesses, entrust these to faithful men who will be qualified to teach others." },
  { ref: "Deuteronomy 6:6\u20137", tr: "WEB", text: "These words, which I command you today, shall be on your heart; and you shall teach them diligently to your children." },
  { ref: "Colossians 3:16", tr: "BSB", text: "Let the word of Christ richly dwell within you as you teach and admonish one another with all wisdom." },
];

export const ScriptureDivider = () => {
  const [verse] = useState(() => VERSES[Math.floor(Math.random() * VERSES.length)]);
  return (
    <section className="relative py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1.2, ease: EASE }}
          className="relative bg-paperwhite rounded-[2rem] border border-ink/5 shadow-lg p-10 md:p-16 text-center"
          data-testid="scripture-card"
        >
          <div className="pointer-events-none absolute -inset-8 -z-10 rounded-[2.5rem] bg-green/5 blur-3xl" />
          <span
            data-testid="scripture-ref"
            className="inline-block rounded-full bg-plum/10 text-plum text-xs font-semibold uppercase tracking-[0.15em] px-4 py-1.5 mb-8"
          >
            {verse.ref} · {verse.tr}
          </span>
          <p
            data-testid="scripture-text"
            className="font-serif italic text-2xl md:text-4xl leading-relaxed text-ink text-balance"
          >
            "{verse.text}"
          </p>
          <div className="mt-10 mx-auto w-16 h-px bg-ink/15" />
        </motion.div>
      </div>
    </section>
  );
};
